// #510: the time zones an athlete can pick in Preferences. A short static
// list of regions, never a city: the profile says on which day a session
// fell, not where the athlete lives (Antenore, 29/10, GDPR). Each region
// stores ONE reference IANA id, which carries its daylight-saving rule.
// Ordered west to east by standard-time offset. The label is the i18n key
// `mobile.prefs.timeZoneRegion.<region>`.

export const ATHLETE_TIME_ZONES = [
  { id: "Pacific/Honolulu", region: "hawaii" },
  { id: "America/Anchorage", region: "alaska" },
  { id: "America/Los_Angeles", region: "naPacific" },
  { id: "America/Denver", region: "naMountain" },
  { id: "America/Chicago", region: "naCentral" },
  { id: "America/Mexico_City", region: "mexico" },
  { id: "America/New_York", region: "naEastern" },
  { id: "America/Bogota", region: "southAmericaWest" },
  { id: "America/Halifax", region: "atlanticCanada" },
  { id: "America/Sao_Paulo", region: "southAmericaEast" },
  { id: "Europe/London", region: "ukIreland" },
  { id: "Africa/Lagos", region: "westAfrica" },
  { id: "Europe/Berlin", region: "centralEurope" },
  { id: "Europe/Athens", region: "easternEurope" },
  { id: "Africa/Johannesburg", region: "southernAfrica" },
  { id: "Europe/Istanbul", region: "turkeyMiddleEast" },
  { id: "Europe/Moscow", region: "westernRussia" },
  { id: "Asia/Dubai", region: "gulfCaucasus" },
  { id: "Asia/Karachi", region: "pakistanCentralAsia" },
  { id: "Asia/Kolkata", region: "india" },
  { id: "Asia/Bangkok", region: "southeastAsiaWest" },
  { id: "Asia/Shanghai", region: "chinaSoutheastAsia" },
  { id: "Australia/Perth", region: "westernAustralia" },
  { id: "Asia/Tokyo", region: "japanKorea" },
  { id: "Australia/Adelaide", region: "australiaCentral" },
  { id: "Australia/Sydney", region: "australiaEast" },
  { id: "Pacific/Auckland", region: "newZealand" },
] as const;

export type AthleteTimeZone = (typeof ATHLETE_TIME_ZONES)[number]["id"];

export const ATHLETE_TIME_ZONE_IDS = ATHLETE_TIME_ZONES.map((z) => z.id) as unknown as readonly [
  AthleteTimeZone,
  ...AthleteTimeZone[],
];
